import { useUIStore } from '@uofu-uss-gis/ui-react';
import { useAuthStore } from '../../store/authStore';
import ClassRow from './ClassRow';
import { useTheme } from '@mui/material/styles';

const MyClassesList = () => {
  const { payload: myClasses, user } = useAuthStore();
  const { setMyClassesOpen } = useUIStore();
  const theme = useTheme();

  const hasClasses = myClasses && myClasses.length > 0;
  const studentName = hasClasses ? (myClasses[0]?.attributes.NAME || user?.name || 'Student') : (user?.name || 'Student');
  const semester = hasClasses ? (myClasses[0]?.attributes.DESCR || '') : '';

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b bg-u-red text-white">
        <div className="flex justify-between items-start mb-2">
          <div>
            <p className="font-bold text-lg">{studentName}</p>
            <p className="text-sm opacity-90">{semester}</p>
          </div>
          <button
            type="button"
            onClick={() => setMyClassesOpen(false)}
            className="text-white hover:opacity-75"
            aria-label="Close My Classes panel"
          >
            ×
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        {hasClasses ? (
          myClasses.map((classInfo, index) => (
            <ClassRow key={index} classInfo={classInfo} index={index} />
          ))
        ) : (
          <div className="p-6 text-center" style={{ color: theme.palette.text.secondary }}>
            <p className="mb-2">No classes found for this semester.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MyClassesList;
